import { snakeCaseToDisplayName } from 'src/utils/string/stringUtils'

export function prettifyHunterParkingPhotoTaskName(flow: string): string {
    const words = flow.split(',')

    return words.map(snakeCaseToDisplayName).join(' & ')
}
